import { TabList, TabPanel, TabPanels, Tabs } from '@reach/tabs';
import cls from 'classnames';
import { isValidElement } from 'react';
import { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import TabButton from '../base/TabButton';

import useStyles from './styles';
import ITabSection, { ITabItem } from './types';

const SectionImage = ({
  item,
  className,
  afterLoad,
  visibleByDefault,
}: {
  item: ITabItem;
  className: string;
  afterLoad: () => void;
  visibleByDefault: boolean;
}) => {
  if (isValidElement(item.imgUrl)) {
    return item.imgUrl;
  }

  return (
    <LazyLoadImage
      className={className}
      src={item.imgUrl as string}
      sizes={item.sizes}
      srcSet={item.srcSet}
      alt={item.imgAlt}
      afterLoad={afterLoad}
      visibleByDefault={visibleByDefault}
    />
  );
};

function TabSection({
  title,
  subtitle,
  items,
  className,
  imgBackgroundClassName,
  titleClassName,
  tabsDescriptionClassName,
  imgHasBackground,
  titleElement = 'h1',
}: ITabSection) {
  const classes = useStyles();
  const Tag = titleElement;
  const [isViewed, setIsViewed] = useState(false);

  return (
    <section className={cls(className, classes.root, 'landing-banner')}>
      <Tag className={cls('fs-42', classes.title, titleClassName)}>{title}</Tag>

      {subtitle && <p className={cls('fs-16', classes.subtitle)}>{subtitle}</p>}

      <Tabs className={classes.tabs}>
        <TabList className={classes.tabButtons}>
          {items.map((item, i) => (
            <TabButton key={i}>{item.title}</TabButton>
          ))}
        </TabList>

        <TabPanels className={classes.tabPanels}>
          {items.map((item, i) => (
            <TabPanel key={i}>
              <div className={classes.tabContent}>
                <p className={cls('fs-16', tabsDescriptionClassName, classes.description)}>
                  {item.description}
                </p>

                {imgHasBackground ? (
                  <div className={cls(imgBackgroundClassName, classes.imgBackground)}>
                    <SectionImage
                      item={item}
                      className={classes.imageWithBackground}
                      afterLoad={() => setIsViewed(true)}
                      visibleByDefault={isViewed}
                    />
                  </div>
                ) : (
                  <SectionImage
                    item={item}
                    className={classes.imageWithBackground}
                    afterLoad={() => setIsViewed(true)}
                    visibleByDefault={isViewed}
                  />
                )}
              </div>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </section>
  );
}

export default TabSection;
